import { Pipe, PipeTransform } from '@angular/core';
import { formatTimeAgo } from '@shared/dates-time-ago';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {
  // Relative Date Internationalization
  // https://blog.webdevsimplified.com/2020-07/relative-time-format/

  transform(dateString: string): string {
    return dateString ? formatTimeAgo(new Date(dateString)) : null;
  }
}
